
<div class="row justify-content-center">
    <div class="col-10">
        <Loader v-if="row.item.flags === undefined" />
        <div v-else-if="row.item.flags && row.item.flags.length" class="row flags_row">
            <div class="col-12">
                <h4>{{ $t("flags") }}</h4>
                <div class="row align-items-center flags_row_item" v-for="n in row.item.flags" :key="n.id">
                    <div class="col col-1 text-center">
                        <RiskLevelDumpling :value="n.risk" :level="versionRiskLevel(n, version)" />
                    </div>
                    <div class="col col-11 flag_description">
                        <h5>
                            {{ n.flag_type_name }}
                            <a :href="flagUrl(n.flag_type_documentation_url)" target="_blank" v-if="n.flag_type_documentation_url">
                                <b-icon-question-circle
                                    font-scale="0.95"
                                    variant="dark"
                                    class="ml-1"
                                />
                            </a>
                        </h5>
                        <p>{{ n.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
